export enum ActionButtonType {
  SINGLE = 'single',
  BULK = 'bulk',
}
